import { getAuthToken } from './authToken'
export default getAuthToken
